export default __webpack_public_path__ + "static/qrcode-5c45cadb8e28218ddf6b5a5b89499e91.png";